import { ChangeDetectionStrategy, Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ComponentFactory } from './component.factory';

@Component({
  selector: 'gtd-ui-field-dynamic',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicComponent implements OnInit {
  constructor(private viewContainerRef: ViewContainerRef) {}
  @Input() type: string;
  @Input() data: any;
  @Input() rowId: number;
  @Input() row: any;
  @Input() key?: string;
  @Input() source: string;

  public ngOnInit(): void {
    if (typeof this.key === 'string') {
      this.data = this.objValueByKeyPoint(this.key, this.row);
    }
    ComponentFactory.create(this.viewContainerRef, {
      type: this.type,
      data: this.data,
      row: this.row,
      source: this.source,
    });
  }

  private objValueByKeyPoint(key: string, data: Record<string, any>): any {
    return key.split('.').reduce((prev, value) => prev?.[value], data);
  }
}
